/* eslint-disable */
export const config = {
    refreshRates: [0, 60],
    prods: ['aiko', 'alpha', 'histo.model', 'wms.histo', 'wms.preprod'],
    baseUrl: process.env.VUE_APP_ENV === 'dev' ? 'http://localhost:8000/api/v1/' : 'https://api.dashboard.wmstack.ovh/api/v1/',
};
